import React, { Suspense, useLayoutEffect, useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Header, Footer, Loading } from './components'
import { AppWrapper, MaintenancePage } from './pages'
import ScrollToTop from './ScrollToTop'
import Routes, { MobileRoutes } from './routes'
import { configKeys, remoteConfig } from './service/firebase'
import FirebasePushNotif from './components/Notification/FirebasePushNotif'

function App() {
  const [loading, setLoading] = useState(true)
  const [isMaintenance, setIsMaintenance] = useState()

  const getRemoteConfigValue = async () => {
    setLoading(true)
    try {
      await remoteConfig.fetchAndActivate()
    } catch (err) {
      console.log('failed to get config data: ', err)
    } finally {
      setLoading(false)

      const maintenance = remoteConfig.getValue(configKeys.isMaintenance)
      setIsMaintenance(maintenance.asBoolean())
    }
  }

  useLayoutEffect(() => {
    getRemoteConfigValue()
  }, [])

  if (loading || typeof isMaintenance !== 'boolean') {
    return <Loading height='100vh' />
  }

  return (
    <Router>
      <ScrollToTop>
        <Suspense fallback={<Loading height='100vh' />}>
          {isMaintenance ? (
            <>
              <MaintenancePage />
            </>
          ) : (
            <Switch>
              <Route path='/mobile' component={MobileRoutes} />
              <Route
                path='/'
                component={() => (
                  <AppWrapper>
                    <FirebasePushNotif />
                    <Header />
                    <Routes />
                    <Footer />
                  </AppWrapper>
                )}
              ></Route>
            </Switch>
          )}
        </Suspense>
      </ScrollToTop>
    </Router>
  )
}

export default App
